import { Seo } from "../components/Seo";
import { HeroSection } from "../components/HeroSection";
import { SensorExplorer } from "../components/SensorExplorer";
import { BrandMarquee } from "../components/BrandMarquee";
import { HowItWorks } from "../components/HowItWorks";
import { ServicesGrid } from "../components/ServicesGrid";
import { SensorFinder } from "../components/SensorFinder";
import { ProductCatalog } from "../components/ProductCatalog";
import { WhyUs } from "../components/WhyUs";

export default function HomePage() {
  return (
    <main>
      <Seo
        title="حساسات كفرات الرياض | بيع وبرمجة وفحص حساسات ضغط الإطارات TPMS"
        description="حساسات كفرات الرياض — متخصصون في بيع وبرمجة وفحص واستبدال حساسات ضغط الإطارات TPMS في الرياض. نساعدك في اختيار الحساس المتوافق مع سيارتك. استفسر عبر واتساب."
        path="/"
      />
      <HeroSection />
      <SensorExplorer />
      <BrandMarquee />
      <HowItWorks />
      <ServicesGrid />
      <SensorFinder />
      <ProductCatalog />
      <WhyUs />
    </main>
  );
}
